import { createContext } from "react";

export const initialState = { displayed: false };
export const initialActions = {};

export const FavoritesStateContext = createContext(initialState);
export const FavoritesActionsContext = createContext(initialActions);
